module Dashboard {
    export class ExecutionGraphWidgetConfig implements IWidgetConfig {
        public id: string;
        public enabledByDefault: boolean;
        public displayName: string;
        public directiveName: string;
        public gridItemConfig: IGridItemConfig;
        public rangeInDays: number;
        public showingSuccesses: boolean;
        public environments: string[];

        constructor(id: string) {
            this.id = id;
            this.enabledByDefault = true;
            this.displayName = FRENDS.Localizations.ProcessExecutionsGraph;
            this.directiveName = "frends-execution-graph-widget";
            this.gridItemConfig = { col: 6, row: 0, sizeX: 8, sizeY: 6, disableResizing: false };
            this.rangeInDays = 7;
            this.showingSuccesses = true;
            this.environments = [];
        }
    }

    export interface IChartDataPoint {
        date: string;
        count: number;
    }
}